import { useState } from 'react';
import { CreditCard } from 'lucide-react';
import { Button } from '../../../ui';
import { ImportarFaturaDialog } from './ImportarFaturaDialog';

interface Props {
  companyId: string;
}

export function ImportarFaturaButton({ companyId }: Props) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button variant="ghost" disabled={!companyId} onClick={() => setOpen(true)}>
        <CreditCard className="w-4 h-4 mr-1" /> Importar fatura
      </Button>
      <ImportarFaturaDialog open={open} onClose={() => setOpen(false)} companyId={companyId} />
    </>
  );
}
